module.exports = __webpack_public_path__ + "static/media/10_l_plakati_0_67.5.da1f6517.png";